import home from './home';
import channel from './channel';
import goods from './goods';
import order from './order';
import safeguard from './safeguard';
import finance from './finance';
import supplier from './supplier';
import distributor from './distributor';
import authority from './authority';
import channelProvider from './channelProvider';
import tweet from './tweet';

export const router = [
    home,
    channel,
    supplier,
    distributor,
    channelProvider,
    goods,
    tweet,
    order,
    safeguard,
    authority,
    finance,
];

export default router;
